var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRaw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4955_54915)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.934 9.8519C26.8406 9.85085 25.7922 9.41602 25.0191 8.64285C24.2459 7.86968 23.8111 6.82133 23.81 5.72791V0.00390625H5.382C3.95495 0.00390615 2.58632 0.570665 1.57706 1.57955C0.567794 2.58844 0.000530304 3.95686 0 5.38391V37.8279C0.00159014 39.2543 0.569321 40.6217 1.57847 41.6297C2.58762 42.6377 3.95564 43.2039 5.382 43.2039H27.502C28.2089 43.2042 28.909 43.0652 29.5622 42.7948C30.2154 42.5244 30.809 42.1281 31.3089 41.6283C31.8089 41.1285 32.2055 40.5351 32.4761 39.882C32.7467 39.2289 32.886 38.5289 32.886 37.8219V9.8519H27.934Z",
    fill: "#BA4E41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.8861 9.8519H27.9341C26.8406 9.85084 25.7923 9.41602 25.0191 8.64285C24.246 7.86968 23.8111 6.82133 23.8101 5.7279V0.00390625L32.8861 9.8519Z",
    fill: "#BA4E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7879 34.1239H11.7799C10.0059 34.1239 8.56787 35.562 8.56787 37.3359V44.7919C8.56787 46.5659 10.0059 48.0039 11.7799 48.0039H36.7879C38.5618 48.0039 39.9999 46.5659 39.9999 44.7919V37.3359C39.9999 35.562 38.5618 34.1239 36.7879 34.1239Z",
    fill: "#BA4E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5401 42.6779V44.1319H13.0361V42.6779H14.5401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3861 44.1319L17.0841 41.8619H16.7521V44.1319H15.2981V38.1179H17.7821C18.1959 38.1063 18.6068 38.1912 18.9821 38.3659C19.291 38.512 19.5488 38.7475 19.7221 39.0419C19.8896 39.3417 19.9745 39.6806 19.9681 40.0239C19.9794 40.4255 19.8523 40.8188 19.6081 41.1379C19.3388 41.4609 18.968 41.683 18.5561 41.7679L20.0001 44.1319H18.3861ZM16.7521 40.8659H17.6541C17.8845 40.8832 18.1128 40.8117 18.2921 40.6659C18.3632 40.5912 18.4177 40.5024 18.4522 40.4052C18.4866 40.308 18.5002 40.2047 18.4921 40.1019C18.4989 39.9995 18.4846 39.8969 18.4502 39.8002C18.4158 39.7036 18.362 39.615 18.2921 39.5399C18.1155 39.3921 17.8876 39.3202 17.6581 39.3399H16.7561L16.7521 40.8659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4341 43.0359H22.1801L21.8001 44.1319H20.2681L22.4681 38.1619H24.1441L26.3441 44.1319H24.8001L24.4341 43.0359ZM24.0601 41.9299L23.3121 39.7179L22.5541 41.9299H24.0601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.092 38.1179L33.656 44.1319H31.856L30.894 40.1099L29.924 44.1319H28.124L26.686 38.1179H28.268L29.042 42.4739L30.096 38.1179H31.696L32.75 42.4739L33.532 38.1179H35.092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0679 24.7359H8.2119C7.83205 23.7355 7.6382 22.674 7.6399 21.6039C7.63844 20.5345 7.83229 19.4737 8.2119 18.4739C8.36309 18.078 8.5429 17.6937 8.7499 17.3239L9.41991 18.4739L11.2579 21.6279L12.0579 23.0159L13.0679 24.7359Z",
    fill: "#BA4E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2639 27.1719C21.9154 28.8256 20.012 29.933 17.9079 30.2879C17.4642 30.3616 17.0156 30.4017 16.5659 30.4079L17.2739 29.2079L19.0739 26.1359L19.8899 24.7359L20.8899 23.0239L21.8699 24.7359L22.6699 26.1359L23.2639 27.1719Z",
    fill: "#BA4E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.246 21.6039C25.2478 22.6736 25.0532 23.7345 24.672 24.7339C24.5208 25.1318 24.341 25.5181 24.134 25.8899L23.474 24.7339L21.702 21.6399L20.902 20.2399L19.886 18.4659H24.666C25.0503 19.4675 25.2469 20.5312 25.246 21.6039Z",
    fill: "#BA4E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 17.0859H15.4639L16.4819 15.3099L17.2819 13.9099L17.8519 12.9099C20.0112 13.2582 21.963 14.3992 23.3259 16.1099C23.5723 16.4196 23.7975 16.7457 23.9999 17.0859Z",
    fill: "#BA4E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.314 12.8039L15.68 13.9099L13.862 17.0859L13.062 18.4859L12.062 20.2479L11.034 18.4859L10.234 17.0859L9.63403 16.0499C11.0099 14.3559 12.9669 13.2345 15.124 12.9039C15.518 12.8439 15.9156 12.8105 16.314 12.8039Z",
    fill: "#BA4E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4639 26.1279L16.4639 27.8199L15.6639 29.1959L15.0219 30.2959C12.9211 29.9522 11.0162 28.8587 9.65994 27.2179C9.37602 26.8742 9.11797 26.5098 8.88794 26.1279H17.4639Z",
    fill: "#BA4E41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4955_54915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 48,
    fill: "white",
    transform: "translate(0 0.00390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaw);
export default __webpack_public_path__ + "static/media/raw.b459ff4e49e1280d4af6de8ee3405c62.svg";
export { ForwardRef as ReactComponent };